import { Component } from "@angular/core";
import { ResearchAuthService } from "research.oidc.angular";
import { SettingsService } from "research.web.settings";
import { Settings } from "./settings";
import {
  Router,
  RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from "@angular/router";
import { LoadingWrapperService } from "./shared/services/loading-wrapper.service";
import { CurrentUserService } from "./shared/services/current-user.service";

interface UserClaim {
  givenName: string;
  familyName: string;
  username: string;
  name: string;
  email: string;
}

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  private userClaim: UserClaim;
  private localStorageKey = "myUserInfo";
  public settings: Settings;
  public showModal = false;
  public versionNumber = "1.0.0";
  public username: string;
  public year: number = new Date().getFullYear();
  public imageSrc = require("../../src/assets/corteva.svg");
  public myCeLogo = require("../../src/assets/myCeLogo.svg");
  public environment: string;

  get needToRedirect(): boolean {
    return this.userClaim === null || this.userClaim === undefined;
  }

  constructor(
    private auth: ResearchAuthService,
    private settingsService: SettingsService,
    private router: Router,
    private loadingService: LoadingWrapperService,
    private currentUserService: CurrentUserService
  ) {
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        this.loadingService.setMessage("Loading...");
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loadingService.clearMessage();
      }
    });

    auth.onUnathenticatedResponse().subscribe(response => {
      this.currentUserService.clear();
      this.showModal = true;
    });

    window.addEventListener("storage", this.localStorageEventListener, false);

    this.settings = this.settingsService.get<Settings>("_appSettings");
    this.environment = this.settings.environment;

    auth.initialize({
      loginRoute: "/login",
      afterLoginRoute: "/home",
      afterLogoutRoute: "/login",
      signInUrl: this.settings.signInUrl,
      signOutUrl: this.settings.signOutUrl,
      userInfoUrl: this.settings.refreshUrl,
      extendSessionDelay: 600,
      initializeClaims: () => {
        const data = localStorage.getItem(this.localStorageKey);
        if (data) {
          this.setUserClaims(JSON.parse(data) as UserClaim);
        }
        return data;
      },
      getClaims: (response: any) => {
        const shouldNavigate = this.needToRedirect;
        this.setUserClaims(response as UserClaim);
        localStorage.setItem(
          this.localStorageKey,
          JSON.stringify(this.userClaim)
        );

        if (shouldNavigate) {
          router.navigate([auth.afterLoginRoute]);
        }
        return this.userClaim;
      }
    });
  }

  public login(): void {
    this.auth.login();
  }

  public closeModal(): void {
    this.showModal = false;
    this.auth.refresh();
  }

  public logout(): void {
    this.currentUserService.clear();
    localStorage.removeItem(this.localStorageKey);
    this.auth.logout();
  }

  public onActivate(event) {
    window.scroll(0, 0);
  }

  private localStorageEventListener: EventListener = (e: StorageEvent) => {
    const key = e.key;
    // this key needs to match what is set in logout.html
    if (key === "wipeMe") {
      localStorage.removeItem("wipeMe");
      this.logout();
    }
  };

  private setUserClaims(claims: UserClaim): void {
    this.userClaim = claims;
    this.username = claims.username;
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/app.component.ts